module.exports = __webpack_public_path__ + "img/indu_8.f8de42e1.png";